import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Theme } from '../../config/theme';
import { IS_MESSAGING_ENABLED } from '../../utils/Api';

const BG = require('./background.png');
const CLOSE = require('./close.svg');

export default class MobileNav extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={css(styles.container, this.props.isOpen ? styles.container_open : null)}>
        <div className={css(styles.close)} onClick={this.props.toggle} role="button" tabIndex={0} />
        <ul className={css(styles.menu)}>
          <li className={css(styles.item)}>
            <NavLink to="/" className={css(styles.item)} onClick={this.props.toggle}>
              Home
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink to="/find" className={css(styles.item)} onClick={this.props.toggle}>
              Find a Dog
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink to="/shares" className={css(styles.item)} onClick={this.props.toggle}>
              My Dog Shares
            </NavLink>
          </li>
          <li className={css(styles.item)}>
            <NavLink to="/favourites" className={css(styles.item)} onClick={this.props.toggle}>
              My Favourites
            </NavLink>
          </li>
          {IS_MESSAGING_ENABLED && (
            <li className={css(styles.item)}>
              <NavLink
                to="/inbox"
                className={css(styles.item, styles.item_with_badge)}
                onClick={this.props.toggle}
              >
                Messages
                {this.props.unreadCount > 0 && (
                  <span className={css(styles.unread_badge)}>
                    {this.props.unreadCount > 99 ? '99+' : this.props.unreadCount}
                  </span>
                )}
              </NavLink>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

MobileNav.defaultProps = {
  dog: false,
  unreadCount: 0,
};

MobileNav.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  unreadCount: PropTypes.number,
};

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
    backgroundColor: Theme.white,
    backgroundImage: `url(${BG})`,
    backgroundSize: 'cover',
    backgroundPosition: '-500px 0',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 300ms',

    ':before': {
      position: 'absolute',
      height: '100vh',
      width: '100vw',
      top: 0,
      left: 0,
      zIndex: 1,
      backdropFilter: 'blur(20px)',
      content: '""',
    },
  },
  container_open: {
    opacity: 1,
    pointerEvents: 'initial',
  },
  close: {
    position: 'absolute',
    top: 15,
    right: 15,
    left: 'auto',
    zIndex: 6,
    height: 30,
    width: 30,
    backgroundImage: `url('${CLOSE}')`,
    backgroundSize: 'cover',
  },
  menu: {
    position: 'relative',
    zIndex: 2,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  item: {
    display: 'block',
    marginBottom: 40,
    fontSize: 24,
    fontFamily: Theme.font_family_secondary,
    fontWeight: 500,
    color: Theme.white,
    textShadow: '0 2px 2px rgba(0,0,0,.75)',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  item_with_badge: {
    position: 'relative',
  },
  unread_badge: {
    position: 'absolute',
    top: -10,
    right: -30,
    minWidth: 24,
    height: 24,
    padding: '0 6px',
    backgroundColor: Theme.secondary,
    color: Theme.white,
    borderRadius: 12,
    fontSize: 14,
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: Theme.font_family_primary,
    textShadow: 'none',
  },
});



// WEBPACK FOOTER //
// ./src/components/MobileNav/index.js